import { isAndroidApp } from '../../../common/ambient/utils';
import { setThing } from './setThing';

/**
 * Check if external purchase links can be shown based on platform and geolocation.
 *
 * For Android apps: Verifies user is in the US via device country code and IP geolocation
 * For iOS apps and web: Always returns true
 *
 * This action runs once per session and stores the result in Redux state.
 */
export function checkCanShowExternalPurchaseLinks() {
  return async (dispatch, getState) => {
    const { device } = getState();

    // Early return if already checked
    if (device.externalPurchaseLinksChecked) {
      return;
    }

    let canShow = true;

    // Only perform geolocation check for Android apps
    if (isAndroidApp() && device?.countryCode?.code) {
      const deviceCountryCode = device.countryCode.code;

      if (!['US'].includes(deviceCountryCode)) {
        // Device country code is not US
        canShow = false;
        console.log(deviceCountryCode + ' is not US');
      } else {
        // Device country code is US, verify with IP lookup
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 3000);

          const response = await fetch('https://geolocation-db.com/json/', {
            signal: controller.signal
          });
          clearTimeout(timeoutId);

          const ipData = await response.json();
          const ipCountryCode = ipData?.country_code;

          if (ipCountryCode !== 'US') {
            // IP country code doesn't match or couldn't be retrieved
            canShow = false;
            console.log('IP country code mismatch or unavailable:', ipCountryCode);
          }
        } catch (err) {
          console.log('Failed to verify IP country code:', err);
          canShow = false;
        }
      }
    }

    // Store results in Redux state
    dispatch(setThing('canShowExternalPurchaseLinks', canShow));
    dispatch(setThing('externalPurchaseLinksChecked', true));
  };
}
